<template>
    <section
        :class="[
            'content-layout',
            {
                'content-layout--full-width': fullWidth,
            },
        ]"
    >
        <article
            class="content-layout__content"
            :class="contentClass"
        >
            <slot name="content"></slot>
        </article>

        <aside
            v-if="$slots.sidebar"
            class="content-layout__sidebar"
        >
            <slot name="sidebar"></slot>
        </aside>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { useConvertSize } from '@leads.io/design-system-component-library';
import { usePageSettings } from '../../../js/stores/page';
import { storeToRefs } from 'pinia';

const pageSettings = usePageSettings();
const { deviceType } = storeToRefs(pageSettings);

const props = defineProps({
    contentClass: {
        type: String,
        required: false,
        default: null,
    },
    fullWidth: {
        type: Boolean,
        required: false,
        default: false,
    },
    maxWidth: {
        type: Number,
        required: false,
        default: 1312,
    },
    maxContentWidth: {
        type: Number,
        required: false,
        default: 800,
    },
    horizontalPadding: {
        type: String,
        required: false,
        default: 'large',
    },
    alignment: {
        type: String,
        required: false,
        default: 'center',
    },
});

const maxContentWidth = computed(function () {
    if (deviceType.value === 'tablet') {
        return useConvertSize(props.maxContentWidth, { convertToUnit: 'vw2', unitless: true, defaultWindowWidth: 640 }) + 'vw';
    }
    return props.maxContentWidth + 'px';
});

const horizontalPadding = computed(function () {
    switch (props.horizontalPadding) {
        case 'large':
            return 'var(--space-xxl)';
        case 'medium':
            return 'var(--space-xl)';
        case 'small':
            return 'var(--space-m)';
        case 'none':
            return '0';
        default:
            return 'var(--space-xxl)';
    }
});
</script>

<style lang="scss">
@use 'watson-organism-content-layout';
</style>

<style lang="scss" scoped>
@layer organism {
    .content-layout {
        --max-width: v-bind('maxWidth + "px"');
        --max-content-width: v-bind('maxContentWidth');
        --alignment: v-bind('alignment');
        --horizontal-padding: v-bind('horizontalPadding');
    }
}
</style>
